<template>
  <div>
    <div id="heads" class="heads">
      <div class="container headers-wrapper">
        <div class="logo-wrapper">
          <img src="https://www.1778hw.com/cms/image/logo3.png" alt />
        </div>
        <div class="nav-wrapper">
          <el-menu class="el-menu-demo" mode="horizontal" text-color="#222">
            <router-link to="/" class="nav-text">
              <el-menu-item index="1" :class="[path == 'home' ? 'active':'']">首页</el-menu-item>
            </router-link>
            <router-link to="/activityIndex" class="nav-text">
              <el-menu-item
                index="2"
                :class="[path == 'activityIndex' ||path == 'activityDetail'? 'active':'']"
              >活动</el-menu-item>
            </router-link>
            <router-link to="/leaderList" class="nav-text">
              <el-menu-item
                index="3"
                :class="[path == 'leaderList' ||path == 'leaderDetail'? 'active':'']"
              >领队</el-menu-item>
            </router-link>
            <router-link to="/introductionList" class="nav-text">
              <el-menu-item
                index="4"
                :class="[path == 'introductionList'||path == 'introductionDetail' ? 'active':'']"
              >攻略</el-menu-item>
            </router-link>
            <!-- 线路图标的外链 -->
            <span v-for="(item,index) in lineIconArray" :key="index" v-if="item.iconLinkStatus===1">
              <a :href="getURL(item.iconLink)" class="nav-text" target="_blank">
                <el-menu-item index="5">{{item.iconContent}}</el-menu-item>
              </a>
            </span>
            <!-- 线路图标的团队定制 -->
            <span
              v-for="(item,index) in lineIconArray"
              :key="index"
              v-if="item.iconLinkStatus === 2&&isLogin"
            >
              <router-link :to="{path:'/team',query:{id:item.id}}" class="nav-text">
                <el-menu-item index="5" :class="[path == 'team'? 'active':'']">{{item.iconContent}}</el-menu-item>
              </router-link>
            </span>

            <router-link to="/aboutUs" class="nav-text">
              <el-menu-item index="6" :class="[path == 'aboutUs' ? 'active':'']">关于我们</el-menu-item>
            </router-link>
            <router-link to="/userindex/0" class="nav-text" v-if="isLogin">
              <el-menu-item index="7" :class="[path == 'userindex' ? 'active':'']">会员中心</el-menu-item>
            </router-link>
            <span class="nav-text nav-login" @click="tologin" v-if="!isLogin">
              <el-menu-item index="8">注册 / 登录</el-menu-item>
            </span>
            <span class="nav-text nav-login" @click="logout" v-if="isLogin">
              <el-menu-item index="8">注销</el-menu-item>
            </span>
          </el-menu>
        </div>

        <!-- <div class="user-wrapper">
        <div class="user-center" v-if="isLogin">
          <img class="user-img"  @click="goUerCenter" :src="this.$store.state.memberInfo.headPic"/>
        </div>
        <div class="user-btn" v-else>
          <span class="fa fa-user fa-lg"></span>
          <router-link to="/login">登录&nbsp;&nbsp;/</router-link>
          <router-link to="/registered">&nbsp;&nbsp;注册</router-link>
        </div>
        </div>-->
      </div>
    </div>
    <div class="dio">
      <el-dialog
        title="登录"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose"
        :close-on-click-modal="false"
        left
      >
        <div class="dio-content">
          <div class="dio-con">
            <div class="left">
              <img src="https://www.1778hw.com/cms/image/logo3.png" alt />
            </div>
            <div class="right">
              <!-- <div class="wx-text">微信登录</div> -->
              <div class="qr-wrapper">
                <wxlogin
                  :href="href"
                  :appid="appid"
                  :scope="scope"
                  :theme="style"
                  :state="state"
                  :redirect_uri="redirect_uri"
                ></wxlogin>
              </div>

              <!-- <img src="../../../static/images/qr01.jpg" alt class="wx-code" /> -->
            </div>
          </div>
          <div class="dio-bottom">
            请使用微信扫描二维码登录
            <!-- or <span class="dio-phone">手机号登录</span> -->
          </div>
        </div>
        <!-- <span>这是一段信息</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>-->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import wxlogin from "vue-wxlogin";
axios.defaults.withCredentials = true; //传cookie
export default {
  name: "heads",
  data() {
    return {
      activeIndex: "1",
      path: "",
      dialogVisible: false,

      showwx: false,
      appid: "wxc3eca8ba6f06f2fb",
      scope: "snsapi_login",
      state: "bind",
      style: "black",
      redirect_uri: "https://www.1778hw.com%2F%23%2Fwx",
      // redirect_uri: "https://www.1778hw.com/#/wx",
      href: "https://www.1778hw.com/static/images/wcCode.css",
    };
  },
  components: {
    wxlogin,
  },
  computed: {
    lineIconArray() {
      return this.$store.state.lineIconArray;
    },
    enterpriseNav() {
      return this.$store.state.enterpriseNav;
    },
    downloadNav() {
      return this.$store.state.downloadNav;
    },
    serviceArray() {
      return this.$store.state.serviceArray;
    },
    isLogin() {
      return this.$store.state.memberInfo && this.$store.state.memberInfo.id;
    },
  },
  methods: {
    logout() {
      this.$store.commit("saveToken", "");
      this.$store.commit("savememberInfo", "");
      this.$router.push({ path: "/" });
    },
    tologin() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    goUerCenter() {
      this.$router.push({ path: "/user?nav=1" });
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
    },
    getURL(url) {
      let strURL = "";
      if (
        url.substr(0, 7).toLowerCase() === "http://" ||
        url.substr(0, 8).toLowerCase() === "https://"
      ) {
        strURL = url;
      } else {
        strURL = "http://" + url;
      }
      return strURL;
    },
  },
  mounted() {
    this.path = this.$route.name;
    // if (this.isLogin){
    //     this.headPic=this.$store.state.memberInfo.headPic
    // }
    //this.$store.dispatch("getNav")
    //this.getData()
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dio {
  text-align: left;
}
.dio-content {
  width: 100%;
  border-top: 1px solid #cccccc;
}
.dio-con {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}
.left {
  text-align: center;
  width: 50%;
  transform: translateY(30%);
}
.left > img {
  width: 280px;
  /* height: 160px; */
  /* border-right: 1px solid #cccccc; */
}
.wx-code {
  width: 180px;
  height: 180px;
}
.right {
  text-align: center;
  width: 48%;
}
.wx-text {
  color: #007642;
  /* font-weight: bold; */
  font-size: 14px;
}
.qr-wrapper {
  margin: 0 30px;
  line-height: 50px;
}
.qr-wrapper img {
  margin: 0 auto;
  display: block;
  width: 150px;
  height: 150px;
}
.dio-bottom {
  text-align: center;
  color: #757575;
  line-height: 30px;
}
.dio-phone {
  color: #017842;
  cursor: pointer;
}
.dio-phone:hover {
  font-weight: bold;
}
.container {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  /*font-size: 16px !important;*/
}
.heads {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #eee;
  background: #fff;
  z-index: 10;
}
.sptext {
  font-size: 12px;
}
.headers-wrapper {
  display: flex;
}
.logo-wrapper {
  width: 96px;
}
.logo-wrapper img {
  width: 80%;
  /* height: 40px; */
  vertical-align: middle;
}
.name {
  width: 100px;
}
.nav-wrapper {
  padding: 0 15px;
}
.user-wrapper {
  width: 100px;
}
.user-center {
  margin: 6px auto;
  width: 50px;
  height: 50px;
}
.user-center > .user-img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  box-shadow: 0 0 4px #999;
  /*border: 1px solid #999;*/
}
.user-img:hover {
  cursor: pointer;
}
.user-btn {
  background: #409eff;
  background-image: linear-gradient(to right, #409eff 0%, #e92758 100%);
  width: 120px;
  height: 35px;
  line-height: 35px;
  border-radius: 30px;
  font-size: 14px;
  text-align: center;
  margin-top: 15px;
}
.user-btn span {
  color: #fff;
  line-height: 5px;
}
.user-btn a {
  color: #fff;
}
.el-menu--horizontal > .el-menu-item.is-active,
.el-submenu.is-active,
.active {
  background: #007741 !important;
  color: #fff !important;
}
.active-text {
  color: #fff;
}
.active-text:hover {
  color: #222;
}
.is-opened .active-text {
  color: #222 !important;
}
.nav-text {
  display: inline-block;
  float: left;
  height: 60px;
  line-height: 60px;
}
.el-menu-item {
  height: 60px;
  line-height: 60px;
}
.active .el-submenu__title i {
  color: #fff !important;
}
.el-menu-item {
  font-size: 16px !important;
}
.el-submenu__title > a {
  font-size: 16px !important;
}
.el-menu-item > a {
  display: block;
  width: 100%;
  height: 100%;
}
li a {
  /*color: #fff;*/
}
@media screen and (min-width: 1920px) {
  .container {
    width: 1400px;
  }

  .logo-wrapper {
    width: 180px;
  }
  .logo-wrapper img {
    height: 60px;
    vertical-align: middle;
  }
  .user-btn {
    width: 150px;
    height: 50px;
    line-height: 50px;
    border-radius: 50px;
    font-size: 12px;
    text-align: center;
    margin-top: 5px;
  }
  /* .nav-text{
  height: 100px;
  line-height: 100px;
}
  .el-menu-item{
    height: 100px !important;
    line-height: 100px !important;
  }
  .el-menu--horizontal>.el-submenu .el-submenu__title{
    height: 100px !important;
    line-height: 100px !important;
  } */
}
</style>
<style>
.is-opened,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover,
.el-menu-item:hover {
  background: #60f0af !important;
  color: #333 !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover a {
  color: #333 !important;
}
.active .el-submenu__title i {
  color: #fff !important;
}
@media screen and (min-width: 1560px) {
  .container {
    width: 1400px;
  }
}
.dio .el-dialog__title {
  font-size: 14px !important;
  font-weight: bold;
}
.dio .el-dialog__body {
  padding: 0px 20px !important;
}
.nav-login .el-menu-item.is-active {
  color: #000;
}
</style>




// WEBPACK FOOTER //
// src/components/comment/heads.vue